import Pagination from "../../Pieces/Pagination";
export default {
  name: 'AllIntegrations',
  components: {
    Pagination: Pagination
  },
  data: function data() {
    return {
      integrations: [],
      loading: false,
      pagination: {
        current_page: 1,
        per_page: 10,
        total: 0
      }
    };
  },
  methods: {
    fetch: function fetch() {
      var _this = this;
      this.loading = true;
      this.$get('integrations', {
        per_page: this.pagination.per_page,
        page: this.pagination.current_page
      }).then(function (response) {
        _this.integrations = response.integrations.data;
        _this.pagination.total = response.integrations.total;
      })["catch"](function (errors) {
        _this.$handleError(errors);
      }).always(function () {
        _this.loading = false;
      });
    },
    deleteIntegration: function deleteIntegration(id) {
      var _this2 = this;
      this.$del('integrations/' + id).then(function (response) {
        _this2.$notify.success(response.message);
        _this2.fetch();
      })["catch"](function (errors) {
        _this2.$handleError(errors);
      }).always(function () {});
    }
  },
  mounted: function mounted() {
    this.fetch();
  }
};